<div class="row ">
  <div class="col pl-3">
    <h4 class="mb-0 font-header-1 mb-2" style="font-weight: 700;">Reports</h4>
  </div>
</div>
<div class="row mb-2" *ngIf="(global.globalAgencyId!=null && global.globalAgencyId!=undefined  &&
global.globalAgencyId!=''&& global.globalAgencyId!='00000000-0000-0000-0000-000000000000')"> 
 <div class="col pl-0">
    <div widget class="card border-0 box-shadow">

      <div class="card-body  widget-body pt-2 pl-0">
        <section id="tabs" class="project-tab">
          <div class="row">

            <div class="col-lg-12">
              <div class="card-header transparent ml-3 border-0">
                <nav>
                  <div class="nav nav-fill pb-2" id="nav-tab" role="tablist">
                   
                
                    <a class="nav-item nav-link active" id="nav-spenddownpage-tab" data-bs-toggle="tab" href="#nav-spenddownpage"
                      role="tab" aria-controls="nav-spenddownpage" aria-selected="false"
                      (click)="tabchange('spenddownpage')"
                      [ngClass]="{'mytab-inactive':selecctedTab!='spenddownpage','active':selecctedTab=='spenddownpage'}">Spenddown
                      Report</a> 
                       <a class="nav-item nav-link active" id="nav-clientmonitorlist-tab" data-bs-toggle="tab" href="#nav-clientmonitorlist"
                      role="tab" aria-controls="nav-spenddownpage" aria-selected="false"
                      (click)="tabchange('clientmonitorlist')"
                      [ngClass]="{'mytab-inactive':selecctedTab!='clientmonitorlist','active':selecctedTab=='clientmonitorlist'}">Client Monitor List</a> 
                      <!-- <a class="nav-item nav-link" id="nav-revenue-tab" data-bs-toggle="tab" href="#nav-revenue" role="tab"
                      aria-controls="nav-revenue" aria-selected="false" (click)="tabchange('RevenueReport')"
                      [ngClass]="{'mytab-inactive':selecctedTab!='RevenueReport','active':selecctedTab=='RevenueReport'}">Revenue
                      Report</a>
                      <a class="nav-item nav-link" id="nav-ClaimChargevsPaid-tab" data-bs-toggle="tab"
                      href="#nav-ClaimChargevsPaid" role="tab" aria-controls="nav-ClaimChargevsPaid"
                      aria-selected="false" (click)="tabchange('ClaimChargevsPaid')"
                      [ngClass]="{'mytab-inactive':selecctedTab!='ClaimChargevsPaid','active':selecctedTab=='ClaimChargevsPaid'}">Claim
                      Charge vs Paid
                      Report</a> -->
                  </div>
                </nav>
              </div>

              <div class="tab-content" id="nav-tabContent">
                <!-- submission Report -->

              
                <!--InactiveClient Report-->
                <div class="tab-pane fade  " id="nav-inactiveclient" role="tabpanel"
                  aria-labelledby="nav-inactiveclient-tab"
                  [ngClass]="{'active':selecctedTab=='InactiveClientReport','show':selecctedTab=='InactiveClientReport'}">


                  <div class="row mb-2">
                    <div class="col ml-lg-3">
                      <div widget class="card border-0 box-shadow">
                        <div class="card-header transparent  text-muted">

                          <div class="row">
                            <div class="col-lg-6">
                              <h4 class="mb-0 font-header">Inactive Client Report</h4>
                            </div>
                          </div>
                        </div>
                       
                        <div class="card-body  widget-body pb-0 pt-2 mb-4">
                          <div class="row">
                            <div class="col-lg-6" style="border-right: solid 2px #f4cf12;">
                              <div class="row" *ngFor="let val of Reportfilter;let i=index">
                                <div class="col-lg-5 mb-n2">
                                  <label class="manualentry-label" *ngIf="i==0">Filter
                                    <sup class="super-script">&nbsp;*</sup></label>

                                </div>
                                <div class="col-lg-7">

                                  <input type="radio" value="{{val.Key}}" [(ngModel)]="Report.filter" name="i"
                                    [disabled]="global.globalAgencyId=='00000000-0000-0000-0000-000000000000'"
                                    class="mr-1">{{val.Value}}

                                </div>
                              </div>

                              <div class="row mt-3">
                                <div class="col-lg-5">
                                  <label class="manualentry-label">Start
                                    Date</label>
                                </div>
                                <div class="col-lg-7">

                                  <my-date-picker [options]="myDatePickerOptions" [selDate]="Report.start"
                                    placeholder="mm/dd/yyyy"
                                    (inputFieldChanged)="newdates($event,'inputchage','inactivestart')"
                                    (dateChanged)="newdates($event,'datechagned','inactivestart')"
                                    [disabled]="global.globalAgencyId=='00000000-0000-0000-0000-000000000000'">
                                  </my-date-picker>
                                </div>
                              </div>
                              <div class="row mt-3">
                                <div class="col-lg-5">
                                  <label class="manualentry-label">End
                                    Date</label>
                                </div>
                                <div class="col-lg-7">

                                  <my-date-picker [options]="myDatePickerOptions" [selDate]="Report.end"
                                    placeholder="mm/dd/yyyy"
                                    (inputFieldChanged)="newdates($event,'inputchage','inactiveend')"
                                    (dateChanged)="newdates($event,'datechagned','inactiveend')"
                                    [disabled]="global.globalAgencyId=='00000000-0000-0000-0000-000000000000'">
                                  </my-date-picker>
                                </div>

                              </div>




                              <div class="row mt-3">
                                <div class="col-lg-3">
                                </div>
                                <div class="col">
                                  <button type="button" class="btn btn-sm right"
                                    [disabled]="Report.filter== null||Report.filter==undefined||global.globalAgencyId=='00000000-0000-0000-0000-000000000000' || Report.filter==''"
                                    (click)="showInactiveReport($event)">
                                    Generate Report
                                  </button>
                                </div>

                              </div>
                            </div>

                          </div>
                          <div *ngIf="global.globalAgencyId==null || global.globalAgencyId==undefined ||global.globalAgencyId=='00000000-0000-0000-0000-000000000000' || global.globalAgencyId=='' ">
                            <div class="row mt-4 ">
                                <div class="col ">
                                    <div widget class="card border-0 box-shadow">
                                        <div class="card-body  widget-body pt-2">
                                            <div class="text-center text-danger">
                                                <label class="font-red animate-charcter"><i class="fa fa-info-circle fa-lg"></i>&nbsp;Select
                                                    agency to view
                                                    details</label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        </div>

                      </div>
                    </div>
                  </div>

                </div>


                <!--Spenddown Report-->
                <div class="tab-pane fade  " id="nav-spenddownpage" role="tabpanel" aria-labelledby="nav-spenddownpage-tab"
                  [ngClass]="{'active':selecctedTab=='spenddownpage','show':selecctedTab=='spenddownpage'}">

                  <div class="row mb-2">
                    <div class="col ml-lg-3">
                      <div widget class="card border-0 box-shadow">
                        <div class="card-header transparent  text-muted">
                          <div class="row">
                            <div class="col-lg-6">
                              <h4 class="mb-0 font-header">SpendDown Report</h4>
                            </div>
                          </div>
                        </div>
                        <div class="card-body  widget-body pb-0 pt-2 mb-4 mt-2">
                          <div class="alert alert-warning" *ngIf="onDOCFileChangedErr!= '' " closable
                            (close)="onDOCFileChangedErr=''">
                            {{onDOCFileChangedErr}}
                          </div>
                          <div class="row mt-2">
                            <div class="col-lg-2 p-0">
                              <div class="col-lg-12">
                                <label style="font-weight:bold">From </label>
                              </div>
                              <div class="col-lg-12">
                                <my-date-picker [options]="SubmissionmyDatePickerOptions" placeholder="mm/dd/yyyy"
                                  [selDate]="SpendownFilterfromDate"  id="SRFromDate"
                                  (inputFieldChanged)="Spendownnewdates($event, 'inputchanged', 'SpendownFilterfromDate')"
                                  (dateChanged)="Spendownnewdates($event, 'datechanged', 'SpendownFilterfromDate')">
                                </my-date-picker>
                              </div>
                            </div>
                            <div class="col-lg-2 p-0 ms-2">
                              <div class="col-lg-12">
                                <label style="font-weight:bold">To</label>
                              </div>
                              <div class="col-lg-12">
                                <my-date-picker [options]="SubmissionmyDatePickerOptions" placeholder="mm/dd/yyyy"
                                  [selDate]="SpendownFiltertoDate" id="SRToDate"
                                  [disabled]="SpendownFilterfromDate==null || SpendownFilterfromDate==undefined || SpendownFilterfromDate==''"
                                  (inputFieldChanged)="Spendownnewdates($event, 'inputchanged', 'SpendownFiltertoDate')"
                                  (dateChanged)="Spendownnewdates($event, 'datechanged', 'SpendownFiltertoDate')">
                                </my-date-picker>
                              </div>
                            </div>
                            <div class="col-lg-3 p-0  ms-2">
                              <div class="col-lg-12">
                                <label style="font-weight:bold">Client</label>
                              </div>
                              <div class="col-lg-12">
                                <ng-select [(ngModel)]="importBO.clientId" [searchable]="true" [clearable]="true"
                                id="SRClient"
                                  [items]="allClientDropDown" bindLabel="clientName" bindValue="id" groupBy="type">
                                </ng-select>
                              </div>
                            </div>
                            <div class="col-lg-3 p-0 ms-2">
                              <div class="col-lg-12">
                                <label style="font-weight:bold">Service Code </label>
                              </div>
                              <div class="col-lg-12">
                                <ng-select [(ngModel)]="importBO.serviceId" [searchable]="true" [clearable]="true"
                                id="SRService"
                                  [items]="service" bindLabel="masterservice" bindValue="id" groupBy="type">
                                </ng-select>
                              </div>
                            </div>
    
                            <div class="col-lg-1 ms-auto mt-3 d-flex align-items-center">
                             
                              <div class="col-lg-12 ms-2 ">
                                <button (click)="getspendowndata()" class="btn blue-btn btn-sm ml-2"  id="SRApply">
                                  Apply
                                </button>
    
                              </div>
                            </div>
                          </div>
    
                          <div class="row mt-3 mb-1">
                            <div class="col-lg-12 col-lg-2 d-flex">
                              <!-- <label class="mr-2"> Filter</label> -->
                              <div class="d-flex">
                                <div class="d-flex align-items-center justify-content-center">
                              <input type="radio" value="All" [(ngModel)]="spendownfilter" name="All"
                              id="SRAll" class="me-1"
                                (change)="getspendowndata()">All &nbsp;
    
                              <input type="radio" value="True" [(ngModel)]="spendownfilter" name="Printed"
                              id="SRPrinted" class="me-1"
                                (change)="getspendowndata()">Printed &nbsp;
    
                              <input type="radio" value="False" [(ngModel)]="spendownfilter" name="Not Printed"
                              id="SRNotPrinted" class="me-1"
                                (change)="getspendowndata()">Not
                              Printed &nbsp;
                              </div>
                              <div class="ms-3 d-flex align-items-center justify-content-center">
                                <input type="radio" value="null" [(ngModel)]="notPaidInFull" name="sdPaidFilter"
                                 class="me-1" (change)="getspendowndata()"><span (click)="choosePaidFilter('null')">All&nbsp;&nbsp;</span> 
                                <input type="radio" value="false" [(ngModel)]="notPaidInFull" name="sdPaidFilter"
                                class="me-1" (change)="getspendowndata()"><span (click)="choosePaidFilter('false')">Paid in Full &nbsp;&nbsp;</span> 
                                <input type="radio" value="true" [(ngModel)]="notPaidInFull" name="sdPaidFilter"
                                 class="me-1" (change)="getspendowndata()"><span (click)="choosePaidFilter('true')">Not Paid in Full</span> 
                                </div>
                            </div>
                            <div class=" col text-end">
                              <button class="btn blue-btn  ms-2 mb-1 btn-sm" [disabled]="importBO.clientId=='00000000-0000-0000-0000-000000000000'||importBO.clientId==''||
                          importBO.clientId==undefined||importBO.clientId==null" (click)="OpenSpendDownPaymentType('ReceivePayment',null)"
                              id="SRRP">
                              Receive Payment
                            </button>
                              <button class="btn blue-btn  ms-2 mb-1 btn-sm" [disabled]="ParentSpendownId.length==0"
                              (click)="SpendowdBulkList.writeOff=null" 
                              data-bs-target="#BulkUpdateWriteOff" data-bs-toggle="modal" id="SRWOBU">
                              Write Off Bulk Update
                            </button>
                            <button (click)="MarkSpendDownasNotPrinted()" *ngIf="spendownfilter=='True'"
                            [disabled]="ParentSpendownId.length==0" class="btn blue-btn ms-2 mb-1 btn-sm"
                             id="SRMasNotP">
                            Mark as Not-Printed
                          </button>
                              
                              <button (click)="MarkSpendDownasPrinted()" *ngIf="spendownfilter=='False'"
                                [disabled]="ParentSpendownId.length==0" class="btn blue-btn ms-2 mb-1 btn-sm"
                                 id="SRMasP">
                                Mark as Printed
                              </button>
                              <button class="btn blue-btn btn-sm ms-2 mb-1" [disabled]="ParentSpendownId.length==0"
                               (click)="showSpendDown($event)" id="SRPrint">
                              <i class="fa fa-print"></i>
                            </button>
                              <button (click)="Refresh()" class="btn blue-btn btn-sm  ms-2 mb-1"  
                              id="SRRefresh">
                                Refresh
                              </button>
                            </div>
                            </div>
                          </div>
                          <ejs-grid #grid id='grid' [allowResizing]='true' [dataSource]='data | async'
                            (rowSelected)='spendownrowSelected($event)' (checkBoxChange)="spendownselect($event)"
                            allowPaging='true' [allowFiltering]='true' [allowSorting]='true' [pageSettings]='initialPage'
                            [filterSettings]='filterSettings' (dataStateChange)='dataStateChange($event)'
                            [selectionSettings]='selectionOptions' (resizeStop)="onResize($event)"
                            (actionComplete)="onActionComplete($event)" [showColumnChooser]='true'>
                            <e-columns>
                              <e-column type='checkbox' uid="checkbox" width=50 [showInColumnChooser]='false'>
                              </e-column>
                              <e-column uid="action" headerText="Actions" textAlign='center' width=70
                                [showInColumnChooser]='false' [allowEditing]='false' [allowFiltering]="false">
                                <ng-template #template let-data>
                                  <button class="btn btn-edit-table" data-bs-target="#SpendDownDetails" data-bs-toggle="modal"
                                    (click)="editSpendDown(data.spendDownId,data.writeOff)" style="height: 24px"><i
                                      class="fa fa-edit"></i>
                                  </button>

                                  <button  *ngIf="data.balance < 0 " class="btn blue-btn btn-sm ms-3" style="font-size:11px"
                                    (click)="OpenSpendDownPaymentType('ApplyCredit',data)" >Apply Credit
                                  </button>
                                </ng-template>
                              </e-column>
                              <e-column width=100 field="client" headerText="Client Name" type="string"
                                [allowEditing]='false'>
                                <ng-template #filterTemplate let-data>
                                  <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                </ng-template>
                              </e-column>
                              <e-column width=100 field="service_Date" headerText="Service Date" type='date'
                                [format]='formatOptions' [allowFiltering]='false'> </e-column>
    
                              <e-column width=100 field="prepareDate" headerText="Prepared Date" type='date'
                                [format]='formatOptions' [allowFiltering]='false'> </e-column>
                              <e-column width=100 field="service_Code" headerText="Service" type="string"
                                [allowEditing]='false'>
                                <ng-template #filterTemplate let-data>
                                  <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                </ng-template>
                              </e-column>
                              <e-column width=100 field="claimMasterId" headerText="Claim Id" type="number"
                                [allowFiltering]='true' [allowSorting]='true'>
                                <ng-template #filterTemplate let-data>
                                  <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                </ng-template>
                              </e-column>
                              <e-column width=100 field="invoiceDate" headerText="Invoice Date" type='date'
                                [format]='formatOptions' [allowFiltering]='false'> </e-column>
                              <e-column width=100 field="invoiceNumber" headerText="Invoice Number" type="string"
                                [allowFiltering]='true' [allowSorting]='true'>
                                <ng-template #filterTemplate let-data>
                                  <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                </ng-template>
                              </e-column>
                              <e-column width=100 field="invoiceType" headerText="Invoice Type" type="string"
                                [allowFiltering]='true' [allowSorting]='true'>
                                <ng-template #filterTemplate let-data>
                                  <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                </ng-template>
                              </e-column>
                              <e-column width=100 field="amount" headerText="Spend Down Charge" type="number"
                                [allowFiltering]='false'>
                                <ng-template #filterTemplate let-data>
                                  <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                </ng-template>
                              </e-column>
                              <e-column width=100 field="paidAmount" headerText="Spend Down Paid" type="number"
                                [allowFiltering]='true' [allowSorting]='true'>
                                <ng-template #filterTemplate let-data>
                                  <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                </ng-template>
                              </e-column>
                              <e-column width=100 field="paidDate" headerText="Paid Date" type='date'
                                [format]='formatOptions' [allowFiltering]='false'> </e-column>
                              <e-column width=100 field="balance" headerText="Balance" type="number"
                                [allowEditing]='false'>
                                <ng-template #filterTemplate let-data>
                                  <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                </ng-template>
                              </e-column>
                              <e-column width=100 field="writeOff" headerText="Write Off" type="number"
                                [allowFiltering]='true' [allowSorting]='true'>
                                <ng-template #filterTemplate let-data>
                                  <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                </ng-template>
                              </e-column>
                              <e-column width=100 field="printedDate" headerText="Printed Date" type='date'
                                [format]='formatOptions1' [allowFiltering]='false'>
                              </e-column>
                              <e-column width="50" [showInColumnChooser]='false'>
                                <ng-template #headerTemplate let-data>
                                  <div>
                                    <span id='show' (click)='show()'><i class="fa fa-cog fa-lg" aria-hidden="true">
                                      </i></span>
                                  </div>
                                </ng-template>
                              </e-column>
                            </e-columns>
                          </ejs-grid>
                          <div *ngIf="SpendownDataList?.length == 0" class="text-center" style="color:red">
                            <p>No data available</p>
                          </div>
                        </div>
                      </div>

                    </div>
                  </div>
                  <!-- <ng-template #childtemplate let-data>
                    <div>
                     
                      <button class="btnbtn-edit-table" data-bs-target="#SpendDownDetails" data-bs-toggle="modal"
                        (click)="editSpendDown(data.id)" style="height: 24px"><i class="fa fa-edit"></i>
                      </button>
                    </div>
                  </ng-template> -->
                </div>

                <!-- client Monitor list -->

                <!--Spenddown Report-->
                <div class="tab-pane fade  " id="nav-clientmonitorlist" role="tabpanel" aria-labelledby="nav-clientmonitorlist-tab"
                  [ngClass]="{'active':selecctedTab=='clientmonitorlist','show':selecctedTab=='clientmonitorlist'}">

                  <div class="row mb-2">
                    <div class="col ml-lg-3">
                      <div widget class="card border-0 box-shadow">
                        <div class="card-header transparent  text-muted">
                          <div class="row">
                            <div class="col-lg-6">
                              <h4 class="mb-0 font-header">Client Monitor List</h4>
                            </div>
                          </div>
                        </div>
                        <div class="card-body  widget-body pb-0 pt-2 mb-4 mt-2">
                          <div class="row mt-2">
                            <div class="col-lg-2 p-0">
                              <div class="col-lg-12">
                                <label style="font-weight:bold">From </label>
                              </div>
                              <div class="col-lg-12">
                                <my-date-picker [options]="SubmissionmyDatePickerOptions" placeholder="mm/dd/yyyy"
                                  [selDate]="clientmonitorfromdate"  id="CMFromDate"
                                  (inputFieldChanged)="Spendownnewdates($event, 'inputchanged', 'clientmonitorFilterfromDate')"
                                  (dateChanged)="Spendownnewdates($event, 'datechanged', 'clientmonitorFilterfromDate')">
                                </my-date-picker>
                              </div>
                            </div>
                            <div class="col-lg-2 p-0 ms-2">
                              <div class="col-lg-12">
                                <label style="font-weight:bold">To  </label>
                              </div>
                              <div class="col-lg-12">
                                <my-date-picker [options]="SubmissionmyDatePickerOptions" placeholder="mm/dd/yyyy"
                                  [selDate]="clientmonitortodate" id="CMToDate"      
                                  (inputFieldChanged)="Spendownnewdates($event, 'inputchanged', 'clientmonitorFiltertoDate')"
                                  (dateChanged)="Spendownnewdates($event, 'datechanged', 'clientmonitorFiltertoDate')">
                                </my-date-picker>
                              </div>
                            </div>
                            <div class="col-lg-3 p-0  ms-2">
                              <div class="col-lg-12">
                                <label style="font-weight:bold">Status</label>
                              </div>
                              <div class="col-lg-12">
                                 <ng-select class="w-70" [(ngModel)]="getClientlist.statusLId" 
                      style="color: black;" [clearable]="false" [searchable]="true" [items]="statusList"
                      bindLabel="lovName" bindValue="id">

                  </ng-select>
                              </div>
                            </div>
                             <div class="col-3">
                      <label style="font-weight:bold">Monitor</label>
                 
                      <ng-select [items]="monitorList" bindValue="monitorId" [(ngModel)]="getClientlist.monitorId" 
                          placeholder="Select color" >
                          <ng-template ng-label-tmp let-item="item">
                              <i class="fa fa-circle" [ngStyle]="{'color': item.colorCode != null  ? item.colorCode  : (item.value != null ? item.value : '#f2f6f5') }"></i> {{ item.colorandnotes }}
                              <!-- <i class="fa fa-circle" [ngStyle]="{'color': item.value}"></i> {{ item.colorandnotes }} -->
                          </ng-template>

                          <ng-template ng-option-tmp let-item="item">
                              <i class="fa fa-circle" [ngStyle]="{'color': item.colorCode != null  ? item.colorCode  : (item.value != null ? item.value : '#f2f6f5') }"></i> {{ item.colorandnotes }}
                              <!-- <i class="fa fa-circle" [ngStyle]="{'color': item.value}"></i> {{ item.colorandnotes }} -->
                          </ng-template>
                      </ng-select>

                  </div>
    
                            <div class="col-lg-1 me-auto mt-3 d-flex align-items-center">
                               <button (click)="getclientmonitorlist()" class="btn blue-btn btn-sm  me-3"  id="SRApply" >
                                  Apply
                                </button>
                                 <button (click)="RefreshMonitorlist()" class="btn blue-btn btn-sm me-3"  id="SRApply" >
                                  Refresh
                                </button>                              
                            </div>
                          </div>
    
                          <div class="row mt-3 mb-1">
                          </div>
                          <ejs-grid #clientmonitorgrid id='clientmonitorgrid' [allowResizing]='true' [dataSource]='clientmonitordata | async'
                            allowPaging='true' [allowFiltering]='true' [allowSorting]='true' [pageSettings]='initialPagemonitor'
                            [filterSettings]='filterSettings' (dataStateChange)='monitordataStateChange($event)'
                            [selectionSettings]='selectionOptions' (resizeStop)="onResize($event)"
                            (actionComplete)="monitoronActionComplete($event)" [showColumnChooser]='true'>
                            <e-columns>                              
                              <e-column width=100 field="name" headerText="Client Name" type="string"
                                [allowEditing]='false'>
                                <ng-template #filterTemplate let-data>
                                  <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                </ng-template>
                              </e-column>
                              <e-column width=100 field="monitorDate" headerText="Active Date" type='date'
                                [format]='formatOptions' [allowFiltering]='false'> </e-column>
    
                              <e-column width=100 field="inActiveDate" headerText="InActive Date" type='date'
                                [format]='formatOptions' [allowFiltering]='false'> </e-column>                              
                            </e-columns>
                          </ejs-grid>
                          <div *ngIf="SpendownDataList?.length == 0" class="text-center" style="color:red">
                            <p>No data available</p>
                          </div>
                        </div>
                      </div>

                    </div>
                  </div>
                  <!-- <ng-template #childtemplate let-data>
                    <div>
                     
                      <button class="btnbtn-edit-table" data-bs-target="#SpendDownDetails" data-bs-toggle="modal"
                        (click)="editSpendDown(data.id)" style="height: 24px"><i class="fa fa-edit"></i>
                      </button>
                    </div>
                  </ng-template> -->
                </div>
                <!--Revenue Report-->
                <div class="tab-pane fade  " id="nav-revenue" role="tabpanel" aria-labelledby="nav-revenue-tab"
                  [ngClass]="{'active':selecctedTab=='RevenueReport','show':selecctedTab=='RevenueReport'}">

                  <div class="row mb-2">
                    <div class="col ml-lg-3">
                      <div widget class="card border-0 box-shadow">
                        <div class="card-header transparent  text-muted">

                          <div class="row">
                            <div class="col-lg-6">
                              <h4 class="mb-0 font-header">Revenue Report</h4>
                            </div>



                          </div>

                        </div>

                        <div class="card-body  widget-body pb-0 pt-2 mb-4">
                          <div class="row">
                            <div class="col-lg-6" style="border-right: solid 2px #f4cf12;">
                              <div class="row">
                                <div class="col-lg-5">
                                  Payor

                                </div>
                                <div class="col-lg-7">
                                  <ng-select [searchable]="true" [clearable]="true" [items]="revenuePayorList"
                                    bindLabel="Value" class="tdropdown" bindValue="Key" [(ngModel)]="selectedPayor">

                                  </ng-select>
                                </div>
                              </div>

                              <div class="row mt-3">
                                <div class="col-lg-5">
                                </div>
                                <div class="col-lg-3">
                                  <input type="radio" value="fromdate" [(ngModel)]="DateFilter" class="me-2"><label>From Date</label>

                                </div>
                                <div class="col-lg-3">
                                  <input type="radio" value="prepareddate"  [(ngModel)]="DateFilter"  class="me-2"><label>Prepared Date</label>

                                </div>
                                
                              </div>
                              <div class="row mt-3">
                                <div class="col-lg-5">
                                  <label class="manualentry-label">Start Date<sup class="super-script">&nbsp;*</sup>
                                  </label>
                                </div>
                                <div class="col-lg-7">

                                  <my-date-picker [options]="Keystatusoption" [selDate]="revenueStart"
                                    placeholder="mm/dd/yyyy"
                                    (inputFieldChanged)="newdates($event,'inputchage','revenuestart')"
                                    (dateChanged)="newdates($event,'datechagned','revenuestart')"
                                    [disabled]="global.globalAgencyId=='00000000-0000-0000-0000-000000000000'">
                                  </my-date-picker>
                                </div>
                              </div>
                              <div class="row mt-3">
                                <div class="col-lg-5">
                                  <label class="manualentry-label">End
                                    Date <sup class="super-script">&nbsp;*</sup></label>
                                </div>
                                <div class="col-lg-7">

                                  <my-date-picker [options]="Keystatusoption" [selDate]="revenueEnd"
                                    placeholder="mm/dd/yyyy"
                                    (inputFieldChanged)="newdates($event,'inputchage','revenueend')"
                                    (dateChanged)="newdates($event,'datechagned','revenueend')"
                                    [disabled]="global.globalAgencyId=='00000000-0000-0000-0000-000000000000'">
                                  </my-date-picker>
                                </div>

                              </div>
                             
                              <div class="row">
                                <div class="col-lg-3"></div>
                                <div class="text-right col">
                                  <button [disabled]="revenueStart==null||revenueStart==undefined||revenueStart==''||revenueEnd==null||revenueEnd==undefined||
                                  revenueEnd=='' " (click)="showrevenue($event)"
                                    class="btn btn-sm right">Generate Report</button>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div *ngIf="global.globalAgencyId=='00000000-0000-0000-0000-000000000000'"
                            class="text-center text-danger">
                            <label class="font-red"><i class="fa fa-info-circle fa-lg"></i>&nbsp;Select agency to view
                              details</label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
                <!-- ClaimChargevsPaid Report -->
                <div class="tab-pane fade  " id="nav-ClaimChargevsPaid" role="tabpanel"
                  aria-labelledby="nav-ClaimChargevsPaid-tab"
                  [ngClass]="{'active':selecctedTab=='ClaimChargevsPaid','show':selecctedTab=='ClaimChargevsPaid'}">
                  <div class="card-body  widget-body pb-0 pt-2 mb-4">

                    <div class="row mb-2">
                      <div class="col ml-lg-3">
                        <div widget class="card border-0 box-shadow">
                          <div class="card-header transparent  text-muted">

                            <div class="row">
                              <div class="col-lg-6">
                                <h4 class="mb-0 font-header">Claim Charge vs Paid Report</h4>
                              </div>
                            </div>
                          </div>
                          <div class="card-body  widget-body pb-0 pt-2 mb-4">
                            <div class="row">
                              <div class="col-lg-6" style="border-right: solid 2px #f4cf12;">
                                <div class="row">
                                  <div class="col-lg-5">
                                    Payor
                                  </div>
                                  <div class="col-lg-7">
                                   
                                    <ng-select [searchable]="true" [clearable]="true" [items]="revenuePayorList"
                                    bindLabel="Value" class="tdropdown" bindValue="Key" [(ngModel)]="selectedClaimPayor">
                                  </ng-select>
                                  </div>
                                </div>
                                <div class="row mt-3">
                                  <div class="col-lg-5">
                                  </div>
                                  <div class="col-lg-3">
                                    <input type="radio" value="fromdate" [(ngModel)]="DateFilterclaim" class="me-2"><label>From Date</label>
  
                                  </div>
                                  <div class="col-lg-3">
                                    <input type="radio" value="prepareddate"  [(ngModel)]="DateFilterclaim"  class="me-2"><label>Prepared Date</label>
  
                                  </div>
                                  
                                </div>
                                <div class="row mt-3">
                                  <div class="col-lg-5">
                                    <label class="manualentry-label">Start Date<sup class="super-script">&nbsp;*</sup>
                                    </label>
                                  </div>
                                  <div class="col-lg-7">
                                    <my-date-picker [options]="Keystatusoption" [selDate]="ClaimStart"
                                      placeholder="mm/dd/yyyy"
                                      (inputFieldChanged)="newdates($event,'inputchage','claimStart')"
                                      (dateChanged)="newdates($event,'datechagned','claimStart')"
                                      [disabled]="global.globalAgencyId=='00000000-0000-0000-0000-000000000000'">
                                    </my-date-picker>
                                  </div>
                                </div>
                                <div class="row mt-3">
                                  <div class="col-lg-5">
                                    <label class="manualentry-label">End
                                      Date <sup class="super-script">&nbsp;*</sup></label>
                                  </div>
                                  <div class="col-lg-7">
                                    <my-date-picker [options]="Keystatusoption" [selDate]="ClaimEnd"
                                      placeholder="mm/dd/yyyy"
                                      (inputFieldChanged)="newdates($event,'inputchage','claimEnd')"
                                      (dateChanged)="newdates($event,'datechagned','claimEnd')"
                                      [disabled]="global.globalAgencyId=='00000000-0000-0000-0000-000000000000'">
                                    </my-date-picker>
                                  </div>
                                </div>
                                <div class="row mt-3">
                                  <div class="col-lg-3"></div>
                                  <div class="text-right col">
                                    <button [disabled]="ClaimStart==null||ClaimStart==undefined||ClaimStart==''||ClaimEnd==null||ClaimEnd==undefined||
                                  ClaimEnd=='' " (click)="showClaimVsPaid($event)"
                                      class="btn btn-sm right">Generate Report</button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div *ngIf="global.globalAgencyId=='00000000-0000-0000-0000-000000000000'"
                      class="text-center text-danger">
                      <label class="font-red"><i class="fa fa-info-circle fa-lg"></i>&nbsp;Select agency to view
                        details</label>
                    </div>
                  </div>
                </div>
                <!-- Financial Report -->
                <div class="tab-pane fade  " id="nav-Financial" role="tabpanel" aria-labelledby="nav-Financial-tab"
                  [ngClass]="{'active':selecctedTab=='Financial','show':selecctedTab=='Financial'}">




                  <div class="row mb-2">
                    <div class="col ml-lg-3">
                      <div widget class="card border-0 box-shadow">
                        <div class="card-header transparent  text-muted">

                          <div class="row">
                            <div class="col-lg-6">
                              <h4 class="mb-0 font-header">Cheques / EFT Details</h4>
                            </div>



                          </div>

                        </div>

                        <div class="card-body  widget-body pb-0 pt-2 mb-4">
                          <div class="row">
                            <div class="col-lg-6" style="border-right: solid 2px #f4cf12;">

                              <div class="row mt-3">
                                <div class="col-lg-5">
                                  <label class="manualentry-label">Start Date<sup class="super-script">&nbsp;*</sup>
                                  </label>
                                </div>
                                <div class="col-lg-7">
                                  <my-date-picker [options]="Keystatusoption" [selDate]="FinancialStart"
                                    placeholder="mm/dd/yyyy"
                                    (inputFieldChanged)="newdates($event,'inputchage','financialStart')"
                                    (dateChanged)="newdates($event,'datechagned','financialStart')"
                                    [disabled]="global.globalAgencyId=='00000000-0000-0000-0000-000000000000'">
                                  </my-date-picker>
                                </div>
                              </div>
                              <div class="row mt-3">
                                <div class="col-lg-5">
                                  <label class="manualentry-label">End
                                    Date <sup class="super-script">&nbsp;*</sup></label>
                                </div>
                                <div class="col-lg-7">

                                  <my-date-picker [options]="Keystatusoption" [selDate]="FinancialEnd"
                                    placeholder="mm/dd/yyyy"
                                    (inputFieldChanged)="newdates($event,'inputchage','financialEnd')"
                                    (dateChanged)="newdates($event,'datechagned','financialEnd')"
                                    [disabled]="global.globalAgencyId=='00000000-0000-0000-0000-000000000000'">
                                  </my-date-picker>
                                </div>

                              </div>

                              <div class="row">
                                <div class="col text-right">
                                  <button [disabled]="FinancialStart==null||FinancialStart==undefined||FinancialStart==''||FinancialEnd==null||FinancialEnd==undefined||
                              this.FinancialEnd=='' " (click)="showCheckEFT($event)"
                                    class="btn btn-sm right">Download</button>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div *ngIf="global.globalAgencyId=='00000000-0000-0000-0000-000000000000'"
                            class="text-center text-danger">
                            <label class="font-red"><i class="fa fa-info-circle fa-lg"></i>&nbsp;Select agency to view
                              details</label>
                          </div>
                        </div>

                      </div>
                    </div>
                  </div>






                </div>
                <!-- Aging Report -->
                <div class="tab-pane fade  " id="nav-Aging" role="tabpanel" aria-labelledby="nav-Aging-tab"
                  [ngClass]="{'active':selecctedTab=='AgingReport','show':selecctedTab=='AgingReport'}">

                  <div class="row mb-2">
                    <div class="col ml-lg-3">
                      <div widget class="card border-0 box-shadow">
                        <div class="card-header transparent  text-muted">
                          <div class="row">
                            <div class="col-lg-6">
                              <h4 class="mb-0 font-header">Aging Report</h4>
                            </div>
                          </div>
                        </div>
                        <div class="card-body  widget-body pb-0 pt-2 mb-4">
                          <div class="row">
                            <div class="row mt-5 ms-3">
                              <div class="col-lg-0">
                              </div>
                              <div class="col-lg-12">
                                <input type="radio" value="PreparedDate" [(ngModel)]="dateType" name="dateType"
                                  [disabled]="global.globalAgencyId=='00000000-0000-0000-0000-000000000000'">&nbsp;
                                Prepared Date
                              </div>
                            </div>
                            <div class="row mt-5 ms-3">
                              <div class="col-lg-0">
                              </div>
                              <div class="col-lg-12">
                                <input type="radio" value="FromDate" [(ngModel)]="dateType" name="dateType"
                                  [disabled]="global.globalAgencyId=='00000000-0000-0000-0000-000000000000'">&nbsp; From
                                Date
                              </div>
                            </div>
                            <hr>
                            <div class="row mt-5 ms-3">
                              <div class="col-lg-0">
                              </div>
                              <div class="col-lg-12">
                                <input type="radio" value="Yes" [(ngModel)]="locBreak" name="locBreak"
                                  [disabled]="global.globalAgencyId=='00000000-0000-0000-0000-000000000000'">&nbsp; With
                                Location Break
                              </div>
                            </div>
                            <div class="row mt-5 ms-3">
                              <div class="col-lg-0">
                              </div>
                              <div class="col-lg-12">
                                <input type="radio" value="No" [(ngModel)]="locBreak" name="locBreak"
                                  [disabled]="global.globalAgencyId=='00000000-0000-0000-0000-000000000000'">&nbsp;
                                Without Location Break
                              </div>
                            </div>
                           

                            <div class="col-lg-12 mt-3 ms-3">
                              <div class="text-left col">
                                <button (click)="showReportAging($event)" class="btn btn-sm"> Generate
                                  Report</button>
                              </div>
                            </div>

                            <!-- </div> -->
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- Utilization report -->
                <div class="tab-pane fade  " id="nav-Utilization" role="tabpanel" aria-labelledby="nav-Utilization-tab"
                  [ngClass]="{'active':selecctedTab=='Utilization','show':selecctedTab=='Utilization'}">
                  <div class="row mb-2">
                    <div class="col ml-lg-3">
                      <div widget class="card border-0 box-shadow">
                        <div class="card-header transparent  text-muted">
                          <div class="row">
                            <div class="col-lg-6">
                              <h4 class="mb-0 font-header">Utilization Report</h4>
                            </div>
                          </div>
                        </div>
                       
                        <div class="card-body  widget-body pb-0 pt-2 mb-4">
                          <div class="row">
                            <div class="col-lg-6" style="border-right: solid 2px #f4cf12;">
                            
                              <div class="row" >
                                <div class="col-lg-6">
                                  <label>Select Client</label>
                                </div>
                                <div class="col-lg-6">
                                  <ng-select [(ngModel)]="reportClientId"  [searchable]="true" 
                                      [clearable]="true" [items]="allClientDropDown" bindLabel="clientName" (ngModelChange)="getAllBudgetsForClient()"
                                      bindValue="id">
                                  </ng-select>
                                </div>
                              </div>
                              <div class="row">
                                <div class="col-lg-6">
                                  <label>Select Budget</label>
                                </div>
                                <div class="col-lg-6">
                                  <ng-select [(ngModel)]="selectedBudgetId"  [searchable]="true" 
                                      [clearable]="true" [items]="allBudgetDropDown" bindLabel="Value" 
                                      bindValue="Key">
                                  </ng-select>
                                </div>
                              </div>
                              
                              <div class="row">
                                <div class="col-lg-6">
                                  <label>Report Type</label> 
                                </div>
                                <div class="col-lg-6">
                                 
                                  <input type="radio" [(ngModel)]="ReportType" name="reportType" value="detail"/> <label>Detailed</label><br>
                                  <input type="radio" [(ngModel)]="ReportType" name="reportType" value="summary"/> <label>Summary</label>
                                </div>
                              </div>
                              



                              <div class="row mt-3">
                                <div class="col-lg-3">
                                </div>
                                <div class="col">
                                  <button type="button" class="btn btn-sm right"
                                    [disabled]="reportClientId == null || reportClientId == undefined || selectedBudgetId == null || selectedBudgetId == undefined"
                                    (click)="showReport()">
                                    Generate Report
                                  </button>
                                </div>

                              </div>
                            </div>

                          </div>
                        </div>

                      </div>
                    </div>
                  </div>





                  <!--  -->


                </div>
              </div>
            </div>
          </div>

        </section>
      </div>
    </div>
  </div>
</div>


<!--select Agency message-->
<div class="row mb-2" *ngIf="(global.globalAgencyId==null ||global.globalAgencyId==undefined ||
global.globalAgencyId=='' || global.globalAgencyId=='00000000-0000-0000-0000-000000000000')
">  <div class="col pl-0">
    <div widget class="card border-0 box-shadow">
      <div class="card-body pt-2">
        <div class="text-center text-danger pt-3">
          <label class="font-red " style="font-size: 13px;"><i class="fa fa-info-circle fa-lg mr-1"></i>&nbsp;Select agency to view details</label>
        </div>
      </div>
    </div>
  </div> 
</div>  

<!-- Open Modal Report//////////////// -->
<span id="openModal3" data-bs-toggle="modal" data-bs-target="#viewReport"></span>
<div class="modal fade" id="viewReport" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
  aria-hidden="true" data-bs-backdrop="static">

  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title font-header">{{reptitle}}</h5>
        <div class="text-right">
          <button class="btn btn-sm mr-2" (click)="closeClaimmodal()">
            Close</button>
        </div>
      </div>
      <div class="modal-body" style="height:600px">
        <ng-container *ngIf="reportcontain == true">
          <div style="width: 100%;height:100%" class="report-border" #reportContainer></div>
        </ng-container>
      </div>
    </div>
  </div>
</div>



<div style="position: absolute; left: -1000px; top: 500px;" *ngIf="batchData!=null">
  <kendo-pdf-export #pdflist paperSize="A4">
    <DIV id="page_1" style="width: 700px;">
      <ng-container *ngFor="let CreatedBatchList of batchData">

        <div class="row pl-0 pr-0">
          <div class="col-lg-10">
            <h5>Submission Report</h5>
          </div>
          <div class="col-lg-2">{{date|date}}</div>
        </div>
        <div class="row pl-0 pr-0">
          <div class="col-lg-12 font-weight-bold">File Name:{{CreatedBatchList?.invoice837P?.file_Name}}</div>
        </div>
        <div class="row pl-0 pr-0">
          <div class="col-lg-12 font-weight-bold">File Creation
            Date:{{CreatedBatchList?.invoice837P?.file_Creation_Date| date:'MM/dd/yyyy'}}</div>
        </div>
        <div class="row pl-0 pr-0">
          <div class="col-lg-12 font-weight-bold">Submission/Control Num:
            {{CreatedBatchList?.invoice837P?.submission_Control_Number}}</div>
        </div>
        <div class="row pl-0 pr-0">
          <div class="col-lg-12 font-weight-bold">
            <h5> {{CreatedBatchList?.invoice837P?.compnay_Name}} </h5>
          </div>
        </div>
        <div class="row pl-0 pr-0">
          <div class="col-lg-1 pr-0 font-weight-bold">
            Claim ID
          </div>
          <div class="col-lg-1 pl-0 pr-0 font-weight-bold">
            From Date
          </div>
          <div class="col-lg-1 pl-1 pr-0 font-weight-bold">
            To Date
          </div>
          <div class="col-lg-1 pl-0 pr-0 font-weight-bold">
            POS
          </div>
          <div class="col-lg-1 pl-0 pr-0 font-weight-bold">
            Procedure
          </div>
          <div class="col-lg-1 pl-0 pr-0 font-weight-bold">
            Modifier
          </div>
          <div class="col-lg-1 pl-0 pr-0 font-weight-bold">
            Rendering
          </div>
          <div class="col-lg-1 pl-0 pr-0 font-weight-bold">
            Last Name
          </div>
          <div class="col-lg-1 pl-1 pr-0 font-weight-bold">
            Units
          </div>
          <div class="col-lg-1 pl-0 pr-0 font-weight-bold">
            Charges
          </div>
          <div class="col-lg-1 pl-0 pr-0 font-weight-bold">
            Net
          </div>
          <div class="col-lg-1 pl-0 pr-0 font-weight-bold">
            Balance
          </div>
        </div>
        <hr
          style="margin-top: 1.5%; border-top: 1px solid rgb(19, 17, 17); width: 100%; box-shadow: 0px 1px 1px #0c0c0c;">

        <ng-container *ngFor="let companyClaim of CreatedBatchList?.invoice837P?.companyClaims">
          <div class="row">
            <div class="col-lg-12">
              <h5>{{companyClaim.companyName}}</h5>
            </div>
          </div>

          <ng-container *ngFor="let val of companyClaim.claimDetail837PInvoice">

            <div class="row pl-0 pr-0">

              <div class="col-lg-4  pr-0 font-weight-bolder">
                {{val?.payor_Name}}
              </div>
              <div class="col-lg-4 pl-0 pr-0 font-weight-bolder">
                {{val?.payor_Id}}
              </div>




            </div>
            <ng-container *ngFor="let val2 of val?.claimDetail">
              <div class="row pl-0 pr-0">

                <div class="col-lg-4  pr-0 font-weight-bolder">
                  {{val2?.client_Last_Name}},&nbsp;{{val2?.client_First_Name}}&nbsp;
                  {{ val2?.client_Middle_Name!=null?val?.client_Middle_Name:''}}
                </div>
                <div class="col-lg-4 pl-0 pr-0 font-weight-bolder">
                  ID:{{val2?.insurence_No}}
                </div>




              </div>
              <ng-container *ngFor="let val1 of val2?.serviceInvoice837P">
                <div class="row  pl-0 pr-0">

                  <div class="col-lg-1">{{val2?.claim_No}}</div>

                  <div class="col-lg-1 pl-0 pr-0">{{val1?.serviceDate| date:'MM/dd/yyyy'}}</div>
                  <div class="col-lg-1 pl-1 pr-0">{{val1?.serviceDate| date:'MM/dd/yyyy'}}</div>
                  <div class="col-lg-1 pl-0 pr-0">{{val1?.service_Location}}</div>
                  <div class="col-lg-1 pl-0 pr-0">{{val1?.service_Code}}</div>
                  <div class="col-lg-1 pl-0 pr-0">{{val?.modifier1}}</div>
                  <div class="col-lg-1 pl-0 pr-0">{{val1?.rendering_Firstname}}</div>
                  <div class="col-lg-1 pl-0 pr-0">{{val1?.rendering_LastName}}</div>
                  <div class="col-lg-1 pl-0 pr-0 text-center">{{val1?.totalUnits}}</div>
                  <div class="col-lg-1 pl-0 pr-0">${{val1?.totalCharges}}</div>
                  <div class="col-lg-1 pl-0 pr-0">${{val1?.totalNetCharges}}</div>
                  <div class="col-lg-1 pl-0 pr-0">${{val1?.totalNetCharges}}</div>
                </div>
              </ng-container>
              <div class="row pl-0 pr-0 mt-2">

                <div class="col-lg-4  pr-0 font-weight-bolder">

                </div>
                <div class="col-lg-4 pl-0 pr-0 font-weight-bolder">

                </div>



                <div class="col-lg-1 pl-0 pr-0 font-weight-bolder text-center">
                  {{val2?.totalUnits}}
                </div>
                <div class="col-lg-1 pl-0 pr-0 font-weight-bolder">
                  ${{val2?.totalCharges}}
                </div>
                <div class="col-lg-1 pl-0 pr-0 font-weight-bolder">
                  ${{val2?.totalNetCharges}}
                </div>
                <div class="col-lg-1 pl-0 pr-0 font-weight-bolder">
                  ${{val2?.totalBalancaCharges}}
                </div>
              </div>
            </ng-container>
          </ng-container>
        </ng-container>

        <hr style="
            margin-top: 1.5%;
            border-top: 1px solid rgb(19, 17, 17);
            width: 100%;
            box-shadow: 0px 1px 1px #0c0c0c;
            ">
        <div class="row">
          <div class="col-lg-6"></div>
          <div class="col-lg-2">Grand Totals:</div>
          <div class="col-lg-1 pl-0 pr-0">{{CreatedBatchList?.invoice837P?.totalUnits}}</div>
          <div class="col-lg-1 pl-0 pr-0">${{CreatedBatchList?.invoice837P?.totalCharges}}</div>

          <div class="col-lg-1 pl-0 pr-0">${{CreatedBatchList?.invoice837P?.totalNetCharges}}</div>

          <div class="col-lg-1 pl-0 pr-0">${{CreatedBatchList?.invoice837P?.totalBalance}}</div>

        </div>
        <hr
          style="margin-top: 1.5%; border-top: 1px solid rgb(19, 17, 17); width: 100%;margin-bottom: 2px; box-shadow: 0px 1px 1px #0c0c0c;">

        <hr style="
          margin-top: 1.5%;
          border-top: 1px solid rgb(19, 17, 17);
          margin-bottom: 6px;
          width: 100%;
          box-shadow: 0px 1px 1px #0c0c0c;
          ">

      </ng-container>
    </DIV>
  </kendo-pdf-export>


</div>





<!-- /////////=======================Exception report=======================================/// -->

<div style="position: absolute; left: -1000px; top: 500px;">
  <kendo-pdf-export #q>
    <div style="width: 700px;" *ngIf="viewFiles">
      <!-- <DIV id="page_1"> -->
      <div>Exception Report</div>
      <ng-container *ngFor="let itembatch of batchDataExceptiondata">
       
        <div *ngIf="viewFiles">
          <div class="font-weight-bold">Exception Report</div>

          <div class="mt-2">{{itembatch.payorDetail.payorName}}</div>

          <div>{{itembatch.payorDetail.payorStreet}}</div>

          <div>{{itembatch.payorDetail.payorCity}} ,&nbsp;{{itembatch.payorDetail.payorState}}
            &nbsp;{{itembatch.payorDetail.payorZiPCode}}</div>
          <div class="font-weight-bold">PayerID:{{itembatch.payorDetail.payorId}}</div>
          <hr style="
    margin-top: 1.5%;
    border-top: 1px solid rgb(19, 17, 17);
    width: 100%;
    box-shadow: 0px 1px 1px #0c0c0c;
    " />
          <div class="row w-100">
            <div class="col-lg-4">
              <div class="font-weight-bold">{{itembatch.companydetails.companyName}}</div>
              <div class="font-weight-bold">{{itembatch.companydetails.companyAddress}}</div>
              <div class="font-weight-bold">{{itembatch.companydetails.companyCity}}</div>
            </div>
            <div class="col-lg-4">
              <div class="font-weight-bold">Payment Method:&nbsp;&nbsp;{{itembatch?.paymentDetail.payment_Method}}</div>
              <div class="font-weight-bold">Chk/EFT
                date:&nbsp;&nbsp;&nbsp;&nbsp;{{itembatch?.paymentDetail.chk_EFT_date|date:'MM/dd/yyyy'}}</div>
              <div class="font-weight-bold">Remittance Amount:&nbsp;{{itembatch?.paymentDetail.remittance_Amount}}</div>
            </div>
            <div class="col-lg-4">
              <div class="font-weight-bold">Provider#:&nbsp;&nbsp;{{itembatch?.paymentDetail.provider}}</div>
              <div class="font-weight-bold">
                Date:&nbsp;&nbsp;&nbsp;&nbsp;{{itembatch?.paymentDetail.date|date:'MM/dd/yyyy'}}</div>
              <div class="font-weight-bold">Check EFT NBR:&nbsp;{{itembatch?.paymentDetail.check_EFT_NBR}}</div>
            </div>
          </div>
          <hr style="
      margin-top: 1.5%;
      border-top: 1px solid rgb(19, 17, 17);
      width: 100%;
      box-shadow: 0px 1px 1px #0c0c0c;
      " />
          <span class="mt-1"></span>
          <ng-container *ngFor="let val of itembatch.patient_ClaimDetail">
            <hr style="
        margin-top: 1.5%;
        border-top: 1px solid rgb(19, 17, 17);
        width: 100%;
        box-shadow: 0px 1px 1px #0c0c0c;
        " />
            <div class="row w-100">

              <div class="col-lg-2">
                Service Date
              </div>
              <div class="col-lg-1">
                POS
              </div>
              <div class="col-lg-1">
                NOS
              </div>
              <div class="col-lg-1">
                Proc
              </div>
              <div class="col-lg-1">
                MOD
              </div>
              <div class="col-lg-1">
                Billed
              </div>
              <div class="col-lg-2">
                Allowed
              </div>
              <div class="col-lg-1">
                Remark
              </div>

              <div class="col-lg-2">
                Payment
              </div>



            </div>
            <hr style="
        margin-top: 1.5%;
        border-top: 1px solid rgb(19, 17, 17);
        width: 100%;
        box-shadow: 0px 1px 1px #0c0c0c;
        " />
            <div class="row w-100">
              <div class="col-lg-4">
                Patient:{{val?.patient}}
              </div>
              <div class="col-lg-2">
                HIC:{{val?.hic}}
              </div>
            </div>

            <div class="row w-100 mt-1 ">
              <div class="col-lg-2">
                Pat Ctrl #:{{val?.patCtrl}}
              </div>
              <div class="col-lg-5 pr-0">
                Payor Claim Number:{{val?.payor_Claim_Number}}
              </div>
              <div class="col-lg-3 ">
                From Date:{{val?.serviceLineDetail[0]?.serviceDate|date:'MM/dd/yyyy'}}
              </div>
              <div class="col-lg-2 pr-0">
                To Date:{{val?.serviceLineDetail[val.serviceLineDetail.length-1]?.serviceDate|date:'MM/dd/yyyy'}}
              </div>

            </div>
            <ng-container *ngFor="let val1 of val.serviceLineDetail">
              <div class="row w-100">

                <div class="col-lg-2">
                  {{val1?.serviceDate|date:'MM/dd/yyyy'}}
                </div>
                <div class="col-lg-1">

                </div>
                <div class="col-lg-1">
                  {{val?.unit}}
                </div>
                <div class="col-lg-1">
                  {{val1.servicecode}}
                </div>
                <div class="col-lg-1">
                  {{val1?.mod}}
                </div>
                <div class="col-lg-1">
                  {{val1?.billedAmt}}
                </div>
                <div class="col-lg-2 pr-0">
                  {{val1?.notes}}
                </div>
                <div class="col-lg-1">
                  {{val1?.denied_Detail}}
                </div>

                <div class="col-lg-2" style="
          text-align: right;
      ">
                  {{val1?.claimed_Amt}}
                </div>



              </div>
            </ng-container>
            <div class="row w-100">

              <div class="col-lg-3">

                <div class="mt-1"> {{val.patient}}</div>
              </div>

              <div class="col-lg-1">

                <div class="mt-1"> PtResp:</div>
              </div>
              <div class="col-lg-1">
                <div></div>
                <div class="mt-1"> 0.00 </div>
              </div>
              <div class="col-lg-1">

              </div>
              <div class="col-lg-1">
                <hr style="
          margin-top: 1.5%;
          border-top: 1px solid rgb(19, 17, 17);
          width: 100%;
          box-shadow: 0px 1px 1px #0c0c0c;
          " />
                {{val.totalBilledAmt}}
              </div>
              <div class="col-lg-3">

              </div>

              <div class="col-lg-2" style="
        text-align: right;
    ">
                <hr style="
          margin-top: 1.5%;
          border-top: 1px solid rgb(19, 17, 17);
          width: 100%;
          box-shadow: 0px 1px 1px #0c0c0c;
          " />
                {{val.totalClaimAmt}}
              </div>



            </div>
          </ng-container>
          <div class="row">
            <div class="col-lg-4">

            </div>
            <div class="col-lg-1">

            </div>
          </div>
        </div>


      </ng-container>
      <!-- </DIV> -->
    </div>
    <ng-template kendoPDFTemplate let-pageNum="pageNum" let-totalPages="totalPages">
      <div class="kendofooter">
        <hr style="
        margin-top: 1.5%;
        border-top: 1px solid rgb(19, 17, 17);
        width: 100%;
        box-shadow: 0px 1px 1px #0c0c0c;
        " />
        <div> Exception notes: Note 1: The full payment was not made on this service line.</div>
        <div> Note 2: Something has already been paid on this.</div>
        <div> Note 3: The payment amount is less than zero.</div>
        <div> Note 4.This is an old format submit claim id, cannot auto-post</div>
      </div>
    </ng-template>
  </kendo-pdf-export>
</div>
<!--=================================InActive Client Report======================================================-->
<div style="position: absolute; left: -1000px; top: 500px;">
  <kendo-pdf-export #pdfinactive paperSize="A4" margin="0.8cm">
    <div style="width: 730px;">
      <div class="row ">
        <div class="col-lg-10 text-center">
          <h5>Inactive Report</h5>
        </div>
        <div class="col-lg-2 pl-0 pr-0">
          {{today| date:'MM/dd/yyyy'}}
        </div>
      </div><br>
      <div class="row">
        <div class="col-lg-3">
          name
        </div>
        <div class="col-lg-2">
          DOB
        </div>
        <div class="col-lg-2">
          email
        </div>
        <div class="col-lg-2">
          Phone Number
        </div>
        <div class="col-lg-2">
          Intake Date
        </div>

      </div>


      <hr style="
    margin-top: 1.5%;
    border-top: 1px solid rgb(19, 17, 17);
    margin-bottom: 6px;
    width: 100%;
    box-shadow: 0px 1px 1px #0c0c0c;
    ">
      <ng-container *ngFor="let item of InactiveClientReport">



        <div class="row">
          <div class="col-lg-3">
            {{item.name}}
          </div>
          <div class="col-lg-2">
            {{item.dob| date:'MM/dd/yyyy'}}
          </div>
          <div class="col-lg-2">
            {{item.email}}
          </div>
          <div class="col-lg-2">
            {{item.phoneNumber}}
          </div>
          <div class="col-lg-2">
            {{item.intakeDate| date:'MM/dd/yyyy'}}
          </div>

        </div>

      </ng-container>
    </div>
  </kendo-pdf-export>
</div>

<!--================================= spend Down pdf=============================================================================-->
<div style="position: absolute; left: -1000px; top: 500px;">
  <kendo-pdf-export #pdfspendown paperSize="A4" forcePageBreak=".page-break" margin="0.8cm">
    <div style="width: 730px;" id="spendownreport">
      <ng-container *ngFor="let item of Spenddown;let i=index">

        
        <div class="row w-100">
          <div class="col-lg-8 pr-0">
            <span> {{item.agencyName}} </span> <br />
            <span> {{item.agencyStreet}} </span> <br />
            {{item.agencyCity}}, {{item.agencyState}} {{item.agencyZip}}
          </div>

          <div class="col-lg-4 pl-0">
            <h5 class="font-weight-bold">Invoice</h5>
            <table class="table table-bordered w-75">
              <th style="background-color:white;color:black ;">#Invoice</th>
              <th style="background-color:white;color:black ;">Date</th>
              <tbody>
                <tr>
                  <td>{{"C000"+item.invoiceNumber}} </td>
                  <td> {{item.invoiceDate| date:'MM/dd/yyyy'}}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div> <br />

        <div class="row">

          <div class="col-lg-5">
            <table class="table table-bordered">
              <th style="background-color:white;color:black ;">Bill To</th>
              <tbody>
                <td>
                  <span>{{item.billto_Name}}</span><br />
                  <span>{{item.billto_Apt}}</span><br
                    *ngIf="(item?.billto_Apt != undefined) && (item?.billto_Apt != null) && (item?.billto_Apt != '')" />
                  <span>{{item.billto_Street}}</span> <br />
                  {{item.billto_City}}, {{item.billto_State}} {{item.billto_Zipcode}}
                </td>
              </tbody>
            </table>
          </div>

          <div class="col-lg-5">
            <table class="table table-bordered">
              <th style="background-color:white;color:black ;">Client</th>
              <tbody>
                <td>
                  <span>{{item.client}}</span><br />
                  <span>{{item.clientApt}}</span><br
                    *ngIf="(item?.clientApt != undefined) && (item?.clientApt != null) && (item?.clientApt != '')" />
                  <span>{{item.clientAddress}}</span> <br />
                  {{item.clientCity}}, {{item.clientState}} {{item.clientZip}}
                </td>
              </tbody>
            </table>
          </div>

        </div> <br />


        <table style="width: 90%;" class="table table-bordered">
          <th style="width:10% ;background-color:white;color:black ;">Quantity</th>
          <th style=" width:60% ;background-color:white;color:black ;">Description</th>
          <th style=" width:15% ;background-color:white;color:black ;">Rate</th>
          <th style=" width:15% ;background-color:white;color:black ;">Amount</th>
          <tbody>
            <tr style="height: 70%;">
              <td></td>
              <td>
                {{item.description}}
                <br />
                <span class="font-weight-bold">Details:</span> <br />
                <span>{{item.service_Date| date:'MM/dd/yyyy'}} - {{item.service_Date| date:'MM/dd/yyyy'}} -
                  {{item.service}} {{" : "+"$"+item.service_Amount}}</span>
                <br>
                <span>{{item.service_Date| date:'MM/dd/yyyy'}} - {{item.service_Date| date:'MM/dd/yyyy'}} -
                  {{item.service}} {{" : "+"$"+item.adjust_amount}}</span>
              </td>
              <td> {{item.amount}}</td>
              <td> {{item.amount}}</td>
            </tr>
            <tr>
              <td></td>
              <td></td>
              <td>Total</td>
              <td>{{item.amount}}</td>
            </tr>

          </tbody>
        </table>
        <span class="page-break" *ngIf="i!=Spenddown.length-1"></span>
      </ng-container>
    </div>
  </kendo-pdf-export>
</div>


<!--========================================Revenue Report======================================================================-->
<div style="position: absolute; left: -1000px; top: 500px;">
  <kendo-pdf-export #pdfrevenue paperSize="A4" margin="0.8cm">
    <div style="width: 730px;">
      <div class="row w-100">
        <div class="col-lg-8">
          <h5>Filterized on {{filterChargevalue}} From {{revenueStart}} To {{revenueEnd}} </h5>
        </div>
        <div class="col-lg-4 ">
          <span> {{today|date:'EEEE, MMMM d, y'}}</span><br />
          <span> {{today |date:'h:mm:ss a'}}</span>
        </div>
      </div><br>
      <ng-container *ngFor="let Revenue of  locationRevenueBO">
        <div class="row">
          <div class="col-lg-2">
            <label class="font-weight-bold">Location Name:</label>
          </div>
          <div class="col-lg-6">
            <label class="font-weight-bold">{{Revenue.locationName}}</label>
          </div>
        </div>
        <div class="row w-100">
          <div class="col-lg-3">
            <label style="float:left">Payor Name</label>
          </div>
          <div class="col-lg-3" *ngIf="filterChargevalue=='Net'">
            <label style="float:right">Net Charges</label>
          </div>
          <div class="col-lg-3" *ngIf="filterChargevalue=='Gross'">
            <label style="float:right">Gross Charges</label>
          </div>
        </div>
        <hr style="
        margin-top: 1.5%;
        border-top: 1px solid rgb(19, 17, 17);
        width: 100%;
        box-shadow: 0px 1px 1px #0c0c0c;
    " />
        <ng-container *ngFor="let Revenuedetails of Revenue.payorRenvenueInfoDetails">
          <div class="row">
            <div class="col-lg-3">
              <label>{{Revenuedetails.payorName}}</label>
            </div>
            <div class="col-lg-3" *ngIf="filterChargevalue=='Net'">
              <label style="float:right">{{Revenuedetails.netCharges | number:'1.2-2'}}</label>
            </div>
            <div class="col-lg-3" *ngIf="filterChargevalue=='Gross'">
              <label style="float:right">{{Revenuedetails.grossCharges | number:'1.2-2'}}</label>
            </div>

          </div>
        </ng-container>
        <div class="row">
          <div class="col-lg-3">
            <label class="font-weight-bold">Total:</label>
          </div>
          <div class="col-lg-3" *ngIf="filterChargevalue=='Net'">
            <label class="font-weight-bold" style="float:right">{{Revenue.netChargeAmount | number:'1.2-2'}}</label>
          </div>
          <div class="col-lg-3" *ngIf="filterChargevalue=='Gross'">
            <label class="font-weight-bold" style="float:right">{{Revenue.grossChargeAmount | number:'1.2-2'}}</label>
          </div>
        </div>
      </ng-container>

    </div>
  </kendo-pdf-export>
</div>
<!--====================================Claim vs Paid==============================================================-->
<div style="position: absolute; left: -1000px; top: 500px;">
  <kendo-pdf-export #pdfClaimvsPaid paperSize="A4" margin="0.8cm">
    <div style="width: 730px;">
      <div class="row w-100">
        <div class="col-lg-10">
          <h5>Claim versus Paid From {{ClaimStart}} To {{ClaimEnd}} </h5>
        </div>
        <div class="col-lg-2">
          <span> {{today|date:'MM/dd/yyyy'}}</span>
        </div>
      </div><br>
     
      <ng-container *ngFor="let details of locationClaimvsPaidDetails">
        <div class="row">
          <div class="col-lg-2">
            <label class="font-weight-bold">Location Name:</label>
          </div>
          <div class="col-lg-6">
            <label class="font-weight-bold">{{details.locationName}}</label>
          </div>
        </div>
        <table style="width: 640px;">
          <tr>
            <td><label class="font-weight-bold" style="float:left">Payor Name</label></td>
            <td><label class="font-weight-bold" style="float:right">Charges</label></td>
            <td><label class="font-weight-bold" style="float:right">Paid Amount</label></td>
            <td><label class="font-weight-bold" style="float:right">Percentage</label></td>
          </tr>

          <ng-container *ngFor="let data of details.payorClaimvsPaidDetails">
            <tr>
              <td><label style="float:left">{{data.groupPayorName}}</label></td>
              <td><label style="float:right">{{data.netChargeAmount | number:'1.2-2'}}</label></td>
              <td><label style="float:right">{{data.paidAmount | number:'1.2-2'}}</label></td>
              <td><label style="float:right">{{data.percentage | number:'1.2-2'}}%</label></td>
            </tr>
          </ng-container>
          <tr>
            <td><label class="font-weight-bold">Total:</label></td>
            <td><label style="float:right" class="font-weight-bold">{{details.netChargeAmount | number:'1.2-2'}}</label>
            </td>
            <td><label style="float:right" class="font-weight-bold">{{details.paidAmount | number:'1.2-2'}}</label></td>
            <td><label style="float:right" class="font-weight-bold">{{details.percentage | number:'1.2-2'}}%</label>
            </td>
          </tr>
        </table>
      </ng-container>

    </div>
  </kendo-pdf-export>
</div>
<!--====================================Finance Report==============================================================-->
<div style="position: absolute; left: -1000px; top: 500px;">
  <kendo-pdf-export #Financepdf paperSize="A4" margin="0.8cm">
    <div style="width: 730px;">
      <div class="row w-100">
        <div class="col-lg-9">
          <h5>Track Payment <span style="font-style:11px">Paid From {{FinancialStart}} To {{FinancialEnd}} </span></h5>
        </div>
        <div class="col-lg-3">
          <span> {{today|date:'MM/dd/yyyy'}}</span>
        </div>
      </div><br>


      <div class="row">
        <div class="col-lg-2">
          Ck/EFT Date
        </div>
        <div class="col-lg-2">
          Deposite Date
        </div>
        <div class="col-lg-2">
          Payment Date
        </div>
        <div class="col-lg-3">
          Trace No
        </div>
        <div class="col-lg-3">
          Remitte Amount
        </div>
      </div>
      <hr style="
      margin-top: 1.5%;
      border-top: 1px solid rgb(19, 17, 17);
      margin-bottom: 6px;
      width: 100%;
      box-shadow: 0px 1px 1px #0c0c0c;
      ">
      <!-- <ng-container *ngFor="let item of ClaimvspaidList"> -->
      <ng-container *ngFor="let item of FinancialList">
        <span class="font-weight-bold">Payer: {{item.payor_Name}}</span>
        <ng-container *ngFor="let item1 of item.lPayerTrackPayments">
          <div class="row">
            <div class="col-lg-2">
              {{item1.checkorFFTdate|date:'MM/dd/yyyy'}}
            </div>
            <div class="col-lg-2">
              {{item1.depositDate|date:'MM/dd/yyyy'}}
            </div>
            <div class="col-lg-2">
              {{item1.paymentMethod}}
            </div>
            <div class="col-lg-3">
              {{ item1.traceno}}
            </div>
            <div class="col-lg-3">
              {{item1.remittanceAmt}}
            </div>
          </div>
        </ng-container>
        <div class="row">
          <div class="col-lg-3"></div>
          <div class="col-lg-9">
            <hr style="
          margin-top: 1.5%;
          border-top: 1px solid rgb(19, 17, 17);
          margin-bottom: 6px;
          width: 100%;
          box-shadow: 0px 1px 1px #0c0c0c;
 ">
          </div>
        </div>
        <div class="row">

          <div class="col-lg-4">

          </div>
          <div class="col-lg-5">
            <span>{{item.payor_Name}}</span>

          </div>
          <div class="col-lg-3">
            <span>{{item.totalAmount}}</span>

          </div>


        </div>
      </ng-container>




    </div>
  </kendo-pdf-export>
</div>
<!--====================================Exception Report ERA============================================================-->
<div style="position: absolute; left: -1000px; top: 500px;">
  <kendo-pdf-export #pdflistsample [keepTogether]="keepTogether" paperSize="A4">
    <div style="width: 700px;" *ngIf="viewFiles835">
         <ng-template kendoPDFTemplate let-pageNum="pageNum" let-totalPages="totalPages">
       
        <div class="kendofooter">
          <div> Exception notes: Note 1: The full payment was not made on this service line.</div>
          <div style="margin-left: 78px;"> Note 2: Something has already been paid on this.</div>
          <div style="margin-left: 78px;">Note 3: The payment amount is less than zero.</div>
          <div style="margin-left: 78px;">Note 4.This is an old format submit claim id, cannot auto-post</div>
        </div>
      </ng-template>
     
      <div class="font-weight-bold">Exception Report</div>
      <div style="width:700px">
        <ng-container *ngFor="let val of exception835list">
          <div class="row">
            <div class="col-lg-7">
              <div class="row">
                <div class="col-lg-4">
                  <label style="font-weight: 600">File Name:</label>
                </div>
                <div class="col-lg-8">
                  <label>{{val.fileName}}</label>
                </div>
              </div>
            </div>
            <div class="col-lg-5">
              <div class="row">
                <div class="col-lg-5">
                  <label style="font-weight: 600">Imported Date:</label>
                </div>
                <div class="col-lg-7">
                  <label>{{val?.importedDate |date: "MM/dd/yyyy"}}</label>
                </div>
              </div>
            </div>
          </div>
          <hr style="
            margin-top: 1.5%;
            border-top: 1px solid rgb(19, 17, 17);
            width: 100%;
            box-shadow: 0px 1px 1px #0c0c0c;
            " />
          <ng-container *ngFor="let transaction of val.transaction835s">
            <div class="row">
              <div class="col-lg-4">
                <div class="font-weight-bold">{{transaction.payorDetail.payorName}}</div>
                <div class="font-weight-bold">{{transaction.payorDetail.payorStreet}}</div>
                <div class="font-weight-bold">{{transaction.payorDetail.payorCity}} </div>
                <div class="font-weight-bold">
                  {{transaction.payorDetail.payorState}},{{transaction.payorDetail.payorZiPCode}} </div>
              </div>
              <div class="col-lg-4">
                <div class="font-weight-bold">{{transaction.companydetails.companyName}}</div>
                <div class="font-weight-bold">{{transaction.companydetails.companyAddress}}</div>
                <div class="font-weight-bold">{{transaction.companydetails.companyCity}}</div>
                <div class="font-weight-bold">
                  {{transaction.companydetails.companyState}},{{transaction.companydetails.companyZip}}</div>
              </div>
              <div class="col-lg-4">
                <div class="font-weight-bold">Payment Method:{{transaction.paymentDetail.payment_Method}}</div>
                <div class="font-weight-bold">Chk/EFT NBR :{{transaction.paymentDetail.check_EFT_NBR }}</div>
                <div class="font-weight-bold">Check EFT date:{{transaction?.paymentDetail.chk_EFT_date| date:
                  "MM/dd/yyyy"}}</div>
                <div class="font-weight-bold">Remittance Amount:{{transaction.paymentDetail.remittance_Amount}}</div>
              </div>
            </div>
            <ng-container *ngFor="let patientClaim of transaction?.patient_ClaimDetails">
              <hr style="
                margin-top: 1.5%;
                border-top: 1px solid rgb(19, 17, 17);
                width: 100%;
                box-shadow: 0px 1px 1px #0c0c0c;
                " />
              <div class="row w-100">
                <div class="col-lg-2">
                  Service Date
                </div>
                <div class="col-lg-1">
                  POS
                </div>
                <div class="col-lg-1">
                  NOS
                </div>
                <div class="col-lg-1">
                  Proc
                </div>
                <div class="col-lg-1">
                  MOD
                </div>
                <div class="col-lg-1">
                  Billed
                </div>
                <div class="col-lg-2">
                  Allowed
                </div>
                <div class="col-lg-2">
                  Remark
                </div>
                <div class="col-lg-1">
                  Payment
                </div>
              </div>
              <hr style="
                margin-top: 1.5%;
                border-top: 1px solid rgb(19, 17, 17);
                width: 100%;
                box-shadow: 0px 1px 1px #0c0c0c;
                " />
              <div class="row">
                <div class="col-lg-5">
                  <div class="row">
                    <div class="col-lg-4">
                      <label style="font-weight: 600">Patient:</label>
                    </div>
                    <div class="col-lg-8">
                      <label>{{patientClaim.patient}}</label>
                    </div>
                  </div>
                </div>
                <div class="col-lg-3">
                  <div class="row">
                    <div class="col-lg-4">
                      <label style="font-weight: 600">HIC:</label>
                    </div>
                    <div class="col-lg-8">
                      <label>{{patientClaim.hic}}</label>
                    </div>
                  </div>
                </div>
                <div class="col-lg-4">
                  <div class="row">
                    <div class="col-lg-4">
                      <label style="font-weight: 600">Pat Ctrl:</label>
                    </div>
                    <div class="col-lg-8">
                      <label>{{patientClaim.patCtrl}}</label>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-lg-5">
                  <div class="row">
                    <div class="col-lg-6">
                      <label style="font-weight: 600">Payor Claim Number:</label>
                    </div>
                    <div class="col-lg-6">
                      <label>{{patientClaim.payor_Claim_Number}}</label>
                    </div>
                  </div>
                </div>
                <div class="col-lg-4">
                  <div class="row">
                    <div class="col-lg-6">
                      <label style="font-weight: 600">From Date:</label>
                    </div>
                    <div class="col-lg-6">
                      <label>{{patientClaim?.fromDate |date: "MM/dd/yyyy"}}</label>
                    </div>
                  </div>
                </div>
                <div class="col-lg-3">
                  <div class="row">
                    <div class="col-lg-6">
                      <label style="font-weight: 600">To Date:</label>
                    </div>
                    <div class="col-lg-6">
                      <label>{{patientClaim?.toDate |date: "MM/dd/yyyy"}}</label>
                    </div>
                  </div>
                </div>

              </div>

              <ng-container *ngFor="let val1 of patientClaim.serviceLineDetail">
                <div class="row w-100">
                  <div class="col-lg-1">
                    {{val1.serviceDate|date:'MM/dd/yyyy'}}
                  </div>
                  <div class="col-lg-1">

                  </div>
                  <div class="col-lg-1">
                    {{val.unit}}
                  </div>
                  <div class="col-lg-1">
                    {{val1.servicecode}}
                  </div>
                  <div class="col-lg-1">
                    {{val1.mod}}
                  </div>
                  <div class="col-lg-1">
                    {{val1.billedAmt}}
                  </div>
                  <div class="col-lg-2 pr-0">
                    {{val1.notes}}
                  </div>
                  <div class="col-lg-3">
                    {{val1.denied_Detail}}
                  </div>

                  <div class="col-lg-1">
                    {{val1.claimed_Amt}}
                  </div>



                </div>
              </ng-container>
              <br>
              <div class="row w-100">
                <div class="col-lg-3 mt-3">
                  <div class="mt-1">{{patientClaim.patient}}</div>
                </div>
                <div class="col-lg-1 mt-3">
                  <div class="mt-1"> PtResp:</div>
                </div>
                <div class="col-lg-1 mt-3">
                  <div></div>
                  <div class="mt-1"> {{patientClaim.totalPtRespAmt}}</div>
                </div>
                <!-- <div class="col-lg-1">
                  </div> -->
                <div class="col-lg-1 mt-1">
                  <hr style="
                    margin-top: 1.5%;
                    border-top: 1px solid rgb(19, 17, 17);
                    width: 100%;
                    box-shadow: 0px 1px 1px #0c0c0c;
                    " />
                  {{patientClaim.totalBilledAmt}}
                </div>
                <div class="col-lg-5">
                </div>
                <!-- &nbsp; -->
                <div class="col-lg-1 ">
                  <hr style="
                    margin-top: 1.5%;
                    border-top: 1px solid rgb(19, 17, 17);
                    width: 100%;
                    text-align: center;
                    box-shadow: 0px 1px 1px #0c0c0c;
                    " />
                  <div> {{patientClaim.totalClaimAmt}}</div>
                </div>
              </div>
            </ng-container>
          </ng-container>
        </ng-container>
      </div>



    </div>

  </kendo-pdf-export>
</div>

  
   



<span id="openReportModal" data-bs-toggle="modal" data-bs-target="#viewReport"></span>
<div class="modal fade " id="viewReport" data-bs-backdrop="static">
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title font-header">Utilization Report</h5>
          <div class="text-right">
            <button class="btn blue-btn btn-sm mr-2" (click)="closemodal()">
              Close</button>
          </div>
        </div>
        <div class="modal-body" style="height:600px">
          <ng-container *ngIf="reportcontain== true">
            <div style="width: 100%;height:100%" class="report-border" #reportContainer></div>
          </ng-container>
        </div>
        <div class="modal-footer">
       
        </div>
      </div>
    </div>
  </div>

  <span id="OpenBulkUpdateWriteOff22" data-bs-target="#BulkUpdateWriteOff" data-bs-toggle="modal"></span>
<div class="modal fade" id="BulkUpdateWriteOff" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
  aria-hidden="true" data-bs-backdrop="static">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title font-header" id="exampleModalLabel"><span>Write Off Bulk Update
          </span>
        </h5>
        <button type="button" data-bs-dismiss="modal" class="close" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-lg-3">
            <label class="label">Write Off<sup class="super-script">&nbsp;*</sup></label>
          </div>
          <div class="col-lg-6 mt-1">
            <input type="number" [(ngModel)]="SpendowdBulkList.writeOff" class="form-control">
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn blue-btn btn-sm" (click)="BulkUpdateWriteoff()"
          [disabled]="SpendowdBulkList.writeOff==0||SpendowdBulkList.writeOff==undefined||SpendowdBulkList.writeOff==null">Save
          & Close</button>
        <button type="button" class="btn blue-btn btn-sm" data-bs-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>

<!-- SpendownDetails -->
<span id="openSpendDownDetails" data-bs-target="#SpendDownDetails" data-bs-toggle="modal"></span>
<div class="modal fade" id="SpendDownDetails" aria-hidden="true" data-bs-backdrop="static">
  <div class="modal-dialog modal-md">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title font-header">Spenddown details</h5>
        <button type="button" class="close" data-bs-dismiss="modal">
          &times;
        </button>
      </div>
     
      <div class="modal-body">
        <div class="col-12 text-danger d-flex mt-1"
        *ngIf="spenDownPaidHistory !=undefined && spenDownPaidHistory.length > 0">
        <span>Note:</span>
        <p><span class=" ml-1 mr-1 w-badge1 w-red">{{spendownhistorycount}}</span></p>
        <span>Click to view Previous Payment Details</span>
      </div>
        <form [formGroup]="SpendDownForm">
          <div class="row">
            <div class="col">
              <div class="row">
                <label class="center-block col-lg-4 col-md-3 col-sm-12 col-xs-12">Invoice Date</label>
                <label  class="col-lg-6">{{
                  spendDownDetails?.invoiceDate | date: "MM/dd/yyyy"
                  }}</label>
              </div>
              <div class="row">
                <label class="center-block col-lg-4 col-md-3 col-sm-12 col-xs-12">Invoice Number</label>
                <label  class="col-lg-6">{{ spendDownDetails?.invoiceNumber }}</label>
              </div>
              <div class="row ">
                <label class="center-block col-lg-4 col-md-3 col-sm-12 col-xs-12">Total Amount</label>
                <label  class="col-lg-6">{{ spendDownDetails?.totalAmount | number: '1.2-2' }}</label>
              </div>
              <div class="row ">
                <label class="center-block col-lg-4 col-md-3 col-sm-12 col-xs-12">Total Paid Amount</label>
                <label  class="col-lg-6">{{ totalSpendDownPaidAmount | number: '1.2-2' }}</label>
              </div>
              <div class="row">
                <label class="center-block col-lg-4 col-md-3 col-sm-12 col-xs-12">Balance</label>
                <label class="col-6 pl-0">{{ spendDownDetails?.balanceAmount | number: '1.2-2' }}</label>
                <!-- Popover Button -->
                <button type="button" id="SpendownPaidRecords" class="pt-0 mt-0 col-1 pr-0 border-0 bg-none"
                  placement="right" [ngbPopover]="popoverSpendDown" popoverTitle="Payment Details" triggers="manual" [autoClose]="false"
                  #popover="ngbPopover" (click)="popover.toggle()"
                  *ngIf="spenDownPaidHistory != undefined && spenDownPaidHistory.length > 0">
                  <p><span class="w-badge w-red">{{spendownhistorycount}}</span></p></button>
              </div>
              <ng-template #popoverSpendDown>
                <div class="p-3" style="min-width: 400px;"> <!-- Increased min-width for better readability -->
                  <!-- Header Section -->
                  <div class="row mb-3">
                    <div class="col-6">
                      <div class="d-flex flex-column">
                        <span class="text-muted small">Total Amount:</span>
                        <span class="font-weight-bold">${{ spendDownDetails?.totalAmount | number: '1.2-2' }}</span>
                      </div>
                    </div>
                    <div class="col-6">
                      <div class="d-flex flex-column">
                        <span class="text-muted small">Balance:</span>
                        <span class="font-weight-bold">${{ spendDownDetails?.balanceAmount | number: '1.2-2' }}</span>
                      </div>
                    </div>
                  </div>
              
                  <!-- Table Section -->
                  <div class="table-responsive" style="max-height: 300px; overflow-y: auto;">
                    <table class="table table-hover table-striped">
                      <thead class="bg-light sticky-top"> <!-- Sticky header -->
                        <tr>
                          <th style="width: 80px;" class="text-center">Action</th>
                          <th style="width: 120px;">Paid Date</th>
                          <th style="width: 120px;" >Paid Amount</th>
                          <th>Check Number</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let ele of spenDownPaidHistory">
                          <td class="text-center">
                            <button class="btn btn-danger btn-sm rounded-circle" 
                                    (click)="deleteSpendownHistory(ele, p)" 
                                    title="Delete">
                              <i class="fa fa-trash fa-sm"></i>
                            </button>
                          </td>
                          <td>{{ ele?.paidDate | date: 'MM/dd/yyyy' }}</td>
                          <td >{{ ele?.paidAmount | number: '1.2-2' }}</td>
                          <td>{{ ele?.checkNumber }}</td>
                        </tr>
                      </tbody>
                      <tfoot class="font-weight-bold bg-light">
                        <tr>
                          <td colspan="2" style="    text-align: center;" >Total:</td>
                          <td >{{ totalSpendDownPaidAmount | number: '1.2-2' }}</td>
                          <td></td>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
              
                  <!-- Footer Section -->
                  <!-- <div class="d-flex justify-content-end mt-3">
                    <button type="button" 
                            class="btn btn-secondary btn-sm" 
                            (click)="closePopover(p)">
                      Close
                    </button>
                  </div> -->
                </div>
              </ng-template>
              <div class="row">
                <label class="center-block col-lg-4 col-md-3 col-sm-12 col-xs-12">Paid Date<sup
                    class="super-script">*</sup></label>
                    <div class=" col-lg-7 col-md-7 col-sm-12 col-xs-12">
                      <my-date-picker class="pl-0 pr-0" name="nmapaiddate"
                      placeholder="mm/dd/yyyy" [options]="myDatePickerOptions" [selDate]="spendDownDetails.formatedPaidDate"
                      formControlName="spendPaidDate" (inputFieldChanged)="SpendPaiddatechange($event)"
                      (dateChanged)="onSpendPaiddatechanged($event)" required>
                    </my-date-picker>
                    </div>
               
              </div>
              <div class="row">
                <label class="center-block col-lg-4 col-md-3 col-sm-12 col-xs-12">Paid Amount<sup
                    class="super-script">*</sup></label>
                    <div class=" col-lg-7">
                <input type="number" [(ngModel)]="this.spendDownDetails.paidAmount" formControlName="spendpaidAmount"
                  class="form-control " />
                </div>
              </div>
              <div class="row mt-2">
                <label class="center-block col-lg-4 col-md-3 col-sm-12 col-xs-12">Write Off</label>
                <div class="col-lg-7">

                  <input type="number" [(ngModel)]="this.spendDownDetails.writeOff" formControlName="writeoff"
                  (ngModelChange)="checkChanges(this.spendDownDetails.writeOff)" class="form-control " />
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <button type="submit" class="btn blue-btn btn-sm" (click)="UpdateSpendDown()"
          [disabled]="SpendDownForm.invalid || spendDownDetails.paidAmount == 0">
          <span> Save & Close</span>
        </button>
        <button type="button" class="btn blue-btn btn-sm" data-bs-dismiss="modal">
          Close
        </button>
      </div>
    </div>
  </div>
</div>


<!-- -----------------------SpenddownPayment Modal -------------------------------------------->
<span id="OpenReceivePaymentPaid" data-bs-target="#SpendownmarkAsPaid" data-bs-toggle="modal"></span>
<div class="modal fade" id="SpendownmarkAsPaid" aria-hidden="true" data-bs-backdrop="static">
  <div class="modal-dialog modal-xl" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title font-header">
          <span *ngIf="this.SpenddownPaymentType=='ReceivePayment'">Receive Payment
          </span><span *ngIf="this.SpenddownPaymentType!='ReceivePayment'">Apply Credit
          </span>
        </h5>
        <!-- <button type="button" class="close" data-bs-dismiss="modal" (click)="this.pagshort.itemperpage=100;this.notPaidInFull='null';getspendowndata();">
          &times;
        </button> -->
        <button type="button" class="close" data-bs-dismiss="modal" *ngIf="this.SpenddownPaymentType!='ReceivePayment'" (click)="this.pagshort.itemperpage=100;this.importBO.clientId=null;this.notPaidInFull='null';getspendowndata();">
          &times;
        </button>
        <button type="button" class="close" data-bs-dismiss="modal" *ngIf="this.SpenddownPaymentType=='ReceivePayment'" (click)="this.pagshort.itemperpage=100;this.notPaidInFull='null';getspendowndata();">
          &times;
        </button>


      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-lg-2" *ngIf="this.SpenddownPaymentType=='ReceivePayment'">
            <div class="row">
              <div class="col-lg-12 ml-1">
                <label class="center-block">Paid Amount<sup class="super-script">*</sup></label>
              </div>
              <div class="col-lg-12 ml-1">
                <input type="number" class="form-control" [(ngModel)]="SpendDownReceivePaidBO.receivePaymentAmt"
                  (input)="onInputChange($event)">
              </div>
            </div>
          </div>
          <div class="col-lg-2" *ngIf="this.SpenddownPaymentType=='ReceivePayment'">
            <div class="row">
              <div class="col-lg-12">
                <label class="center-block">Paid Date<sup class="super-script">*</sup></label>
              </div>
              <div class="col-lg-12">
                <my-date-picker [options]="myDatePickerOptions2" placeholder="mm/dd/yyyy"
                  [selDate]="SpendDownReceivePaidBO.receivePaymentDate"
                  (inputFieldChanged)="newdates($event,'inputchage','ReceivepaidDate')"
                  (dateChanged)="newdates($event,'datechagned','ReceivepaidDate')">
                </my-date-picker>
              </div>
            </div>
          </div>
          <div class="col-lg-2" *ngIf="this.SpenddownPaymentType=='ReceivePayment'">
            <div class="row">
              <div class="col-lg-12">
                <label class="center-block">Check Number</label>
              </div>
              <div class="col-lg-12">
                <input type="text" class="form-control" [(ngModel)]="SpendDownReceivePaidBO.checkNumber">
              </div>
            </div>
          </div>
          <div class="col-lg-4" *ngIf="this.SpenddownPaymentType!='ReceivePayment'">
            
            <label class="center-block"><b class="ml-1 mr-2">Invoice Number</b> : {{this.spendowninvoiceNumber}}</label>
            <br>
            <label class="center-block"><b class="ml-1 mr-3">Credit Amount</b>  : {{this.SpendDownReceivePaidBO.receivePaymentAmt | currency}}</label>

          </div>
          <div class="ml-auto mr-5">
            <div class="row">
              <label class="center-block"><b><span *ngIf="this.SpenddownPaymentType=='ReceivePayment'">Payment Amount</span><span *ngIf="this.SpenddownPaymentType!='ReceivePayment'">Credit Amount</span></b> :
                {{SpendDownReceivePaidBO.receivePaymentAmt | currency}}</label>     
          </div>
          <div class="row">
            <label class="center-block"><b>Selected Transaction</b> :
              {{(SpendDownReceivePaidBO?.totalAppliedAmount || 0).toFixed(2) | currency}}</label>     
        </div>
            <div class="row">
                <label class="center-block"><b class="mr-3">Difference </b> : {{(Spendowndifference || 0).toFixed(2) | currency}}</label>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-12" style="max-height: 300px; overflow-y: scroll;">
           
              <table class="table table-bordered">
                <thead>
                  <tr>
                    <th class="pointer" style="text-align: center;padding:0px; width: 20px;position: sticky; top: 0; z-index: 1;zoom: 1.3;margin-top: 5px">
                      <input type="checkbox" class="mt-1" [checked]="false" (change)="toggleSelectAll($event)"  [disabled]="this.SpendDownReceivePaidBO.receivePaymentAmt==null||this.SpendDownReceivePaidBO.receivePaymentAmt==undefined||this.SpendDownReceivePaidBO.receivePaymentAmt==0"  >
                    </th>
                    <th resizable class="pointer" style="text-align: center; padding:0px;position: sticky; top: 0; z-index: 1;">
                      <span>Client Name</span>
                    </th>
                    <th class="pointer" style="text-align: center; padding:0px;width: 20px;position: sticky; top: 0; z-index: 1;" >
                      <span>Invoice Date</span>
                    </th>
                    <th class="pointer" style="text-align: center;padding:0px; width: 55px;position: sticky; top: 0; z-index: 1;" >
                      <span>Invoice #</span>
                    </th>
                    <th class="pointer" style="text-align: center;padding:0px; width: 100px;position: sticky; top: 0; z-index: 1;" >
                      <span>Invoice Type</span>
                    </th>
                    <th class="pointer" style="text-align: center;padding:0px; width: 75px;position: sticky; top: 0; z-index: 1;" >
                      <span>Invoice Amount</span>
                    </th>
                    <th class="pointer" style="text-align: center;padding:0px; width: 75px;position: sticky; top: 0; z-index: 1;" >
                      <span>Open Balance</span>
                    </th>
                    <th class="pointer" style="text-align: center;padding:0px; width: 40px;position: sticky; top: 0; z-index: 1;" >
                      <span>Payment</span>
                    </th>
                    <!-- <th class="pointer" style="text-align: center;padding:0px; width:75px;position: sticky; top: 0; z-index: 1;" >
                      <span>Current Balance</span>
                    </th> -->
                    <th class="pointer" style="text-align: center;padding:0px; width: 70px;position: sticky; top: 0; z-index: 1;" >
                      <span>Over Payment</span>
                    </th>
                  </tr>
                </thead>
                <tbody style="max-height: 200px; overflow-y: auto">
                  <tr *ngFor="let invoice of SpendownDataList; let i = index">
                    <td style="text-align: center; vertical-align: middle;">
                      <input type="checkbox" [disabled]="this.SpendDownReceivePaidBO.receivePaymentAmt==null||this.SpendDownReceivePaidBO.receivePaymentAmt==undefined||this.SpendDownReceivePaidBO.receivePaymentAmt==0"
                        [(ngModel)]="invoice.selected" style="zoom: 1.3;"
                        (change)="onCheckboxChange(invoice)"
                      />
                    </td>
                    
                    <td style="text-align: center; vertical-align: middle;">{{ invoice.client }}</td>
                    <td style="text-align: center; vertical-align: middle;">{{ invoice.invoiceDate | date: "MM/dd/yyyy" }}</td>
                    <td style="text-align: center; vertical-align: middle;">{{ invoice.invoiceNumber }}</td>
                    <td style="text-align: center; vertical-align: middle;">{{ invoice.invoiceType }}</td>
                    <td style="text-align: center; vertical-align: middle;">{{ invoice.amount | number:'1.2-2'}}</td>
                    <td style="text-align: center; vertical-align: middle;">{{ invoice.balance | number:'1.2-2'}}</td>
                    <td style="text-align: center; vertical-align: middle;">{{ invoice.payment | number:'1.2-2'}}</td>
                    <!-- <td style="text-align: center; vertical-align: middle;">{{ invoice.overpayment | number:'1.2-2'}}</td> -->
                    <td style="text-align: center; vertical-align: middle;">{{ invoice.overpayment | number:'1.2-2'}}</td>
                  </tr>
                </tbody>
              </table>
          </div>
          </div> 
          <hr class="outline-line mt-3" />
          <!-- Items per page dropdown -->
          <div class="row align-items-center mt-2">
            <div class="col-lg-12 d-flex justify-content-between">
              <div>
                <label class="mr-1"><b>Items per page</b>:</label>
                <select [(ngModel)]="this.pageitem" (ngModelChange)="callgetspendowndata(this.pageitem)" class="form-control" style="width: auto; display: inline;">
                  <option *ngFor="let size of [10, 15, 20, 50, 100, 250]" [value]="size">{{size}}</option>
                </select>
              </div>
              <div>
                <label><b class="mr-1">Total Items:</b>{{totalcount}}</label>
              </div>
            </div>
            
            <!-- Pagination Controls -->
            <!-- <div class="col-lg-12" style="text-align: center; margin-top: 20px;">
              <pagination-controls
                (pageChange)="currentPage = $event"
                id="pagination"
                maxSize="5"
                directionLinks="true"
                autoHide="true">
              </pagination-controls>
            </div> -->
          </div>       
      </div>
      <div class="modal-footer">
        <button type="button" class="btn blue-btn btn-sm" (click)="ReceivePaymentPaid()"
          *ngIf="this.SpenddownPaymentType=='ReceivePayment'" [disabled]="SpendDownReceivePaidBO.receivePaymentAmt==0||SpendDownReceivePaidBO.receivePaymentAmt==undefined||SpendDownReceivePaidBO.receivePaymentAmt==null||
                       SpendDownReceivePaidBO.receivePaymentDate==undefined||SpendDownReceivePaidBO.receivePaymentDate==''||SpendDownReceivePaidBO.receivePaymentDate==null || !isselectedspendownrecord
                 ">
          Apply
        </button>
        <button type="button" class="btn blue-btn btn-sm" *ngIf="this.SpenddownPaymentType!='ReceivePayment'"
          (click)="ApplyCreditAmount()" [disabled]="!isselectedspendownrecord">
          Apply
        </button>
        <!-- <button type="button" class="btn blue-btn btn-sm" data-bs-dismiss="modal"
          (click)="this.pagshort.itemperpage=100;this.notPaidInFull='null';getspendowndata();">
          Close
        </button> -->
        <button type="button" class="btn blue-btn btn-sm" data-bs-dismiss="modal" *ngIf="this.SpenddownPaymentType!='ReceivePayment'"
        (click)="this.pagshort.itemperpage=100;this.notPaidInFull='null';this.importBO.clientId=null;getspendowndata();">
        Close
      </button>
      <button type="button" class="btn blue-btn btn-sm" data-bs-dismiss="modal" *ngIf="this.SpenddownPaymentType=='ReceivePayment'"
        (click)="this.pagshort.itemperpage=100;this.notPaidInFull='null';getspendowndata();">
        Close
      </button>


      </div>
    </div>
  </div>
</div>


<span id="openModal3" data-bs-toggle="modal" data-bs-target="#viewAgingReport"></span>
<div class="modal fade" id="viewAgingReport" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
  aria-hidden="true" data-bs-backdrop="static">

  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title font-header" id="{{reptitle}}">{{reptitle}}</h5>
        <div class="text-right">
          <button class="btn blue-btn btn-sm mr-2" (click)="closemodal()" >
            Close</button>
        </div>
      </div>
      <div class="modal-body" style="height:600px">
        <ng-container *ngIf="reportcontain== true">
          <div style="width: 100%;height:100%" class="report-border" #reportContainer></div>
        </ng-container>
      </div>
    </div>
  </div>
</div>